import React, { useState, useEffect, useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import ModernLayout from '../components/modern_layout';
import ModernLoader from '../components/modern_loader';
import ModernCartSidebar from '../components/modern_cart_sidebar';
import ModernWhatsAppModal from '../components/modern_whatsapp_modal';
import { useGlobalToast } from '../components/modern_toast';
import usePageTitle from '../hooks/usePageTitle';
import { buscar_interesses, buscar_dados_usuario, checkout } from '../services/api';

function ModernCheckout() {
  const history = useHistory();
  usePageTitle('Checkout');
  const [loading, setLoading] = useState(true);
  const [cartItems, setCartItems] = useState([]);
  const [showCartSidebar, setShowCartSidebar] = useState(false);
  const [showWhatsAppModal, setShowWhatsAppModal] = useState(false);
  const [formData, setFormData] = useState({
    nomeCompleto: '',
    email: '',
    telefone: '',
    cep: '',
    endereco: '',
    numero: '',
    bairro: '',
    cidade: '',
    estado: ''
  });
  const { addToast } = useGlobalToast();

  useEffect(() => {
    const loadData = async () => {
      try {
        setLoading(true);
        
        // Carregar dados do usuário logado
        const loginData = sessionStorage.getItem('login');

        console.log('Dados de login no sessionStorage:', {
          login: loginData,
          nome_usuario: sessionStorage.getItem('nome_usuario'),
          email_usuario: sessionStorage.getItem('email_usuario'),
          telefone_usuario: sessionStorage.getItem('telefone_usuario'),
          allSessionStorage: Object.keys(sessionStorage).reduce((acc, key) => {
            acc[key] = sessionStorage.getItem(key);
            return acc;
          }, {})
        });

        if (loginData && !loginData.includes('/')) {
          // Buscar dados completos do usuário no servidor
          if (!loginData) {
            console.warn('⚠️ Login do usuário não encontrado, tentando usar fallback do sessionStorage');

            // Fallback para dados do sessionStorage
            const nomeUsuario = sessionStorage.getItem('nome_usuario') ||
                               sessionStorage.getItem('nome') ||
                               sessionStorage.getItem('nomeCompleto') || '';
            const emailUsuario = sessionStorage.getItem('email_usuario') ||
                                sessionStorage.getItem('email') || '';
            const telefoneUsuario = sessionStorage.getItem('telefone_usuario') ||
                                   sessionStorage.getItem('telefone') || '';

            setFormData(prev => ({
              ...prev,
              nomeCompleto: nomeUsuario,
              email: emailUsuario,
              telefone: telefoneUsuario
            }));
          } else {
            try {
              console.log('Buscando dados do usuário no servidor com login:', loginData);

              // Usar a função específica para buscar dados do usuário com login
              const response = await buscar_dados_usuario(loginData);
            
            console.log('Dados do usuário recebidos:', response.data);
            
            if (response && response.data && response.data.data) {
              const userData = response.data.data;
              setFormData(prev => ({
                ...prev,
                nomeCompleto: userData.Nome || userData.nome || prev.nomeCompleto,
                email: userData.Email || userData.email || prev.email,
                telefone: userData.Telefone || userData.telefone || userData.celular || prev.telefone,
                // Preencher dados de endereço se disponíveis
                cep: userData.Cep || userData.cep || userData.CEP || prev.cep,
                endereco: userData.Endereco || userData.endereco || userData.logradouro || prev.endereco,
                numero: userData.Numero || userData.numero || prev.numero,
                bairro: userData.Bairro || userData.bairro || prev.bairro,
                cidade: userData.Cidade || userData.cidade || userData.localidade || prev.cidade,
                estado: userData.Estado || userData.estado || userData.uf || userData.UF || prev.estado
              }));
              console.log('Formulário preenchido com dados do servidor:', {
                nome: userData.Nome || userData.nome,
                email: userData.Email || userData.email,
                temEndereco: !!(userData.Endereco || userData.endereco)
              });

              // Mostrar toast informando que dados foram preenchidos
              if (userData.Nome || userData.nome) {
                addToast('Seus dados foram preenchidos automaticamente', 'success');
              }
            }
            } catch (error) {
              console.warn('Erro ao buscar dados do usuário:', error);

              // Fallback para dados do sessionStorage
              const nomeUsuario = sessionStorage.getItem('nome_usuario') ||
                                 sessionStorage.getItem('nome') ||
                                 sessionStorage.getItem('nomeCompleto') || '';
              const emailUsuario = sessionStorage.getItem('email_usuario') ||
                                  sessionStorage.getItem('email') || '';
              const telefoneUsuario = sessionStorage.getItem('telefone_usuario') ||
                                     sessionStorage.getItem('telefone') || '';

              console.log('Usando dados do sessionStorage como fallback:', {
                nomeUsuario,
                emailUsuario,
                telefoneUsuario
              });

              setFormData(prev => ({
                ...prev,
                nomeCompleto: nomeUsuario,
                email: emailUsuario,
                telefone: telefoneUsuario
              }));
            }
          }
        }

        // Carregar carrinho - priorizar sessionStorage sobre servidor
        let carrinhoFinal = [];
        
        if (sessionStorage.getItem('comprar')) {
          const carrinhoItems = sessionStorage.getItem('comprar').split(';');
          
          carrinhoItems.forEach(function (element) {
            if (element && element.trim()) {
              try {
                const item = JSON.parse(element);
                console.log('Item do carrinho (sessionStorage):', item);
                carrinhoFinal.push(item);
              } catch (error) {
                console.warn('Erro ao parsear item:', element, error);
              }
            }
          });
          
          console.log('Carrinho carregado do sessionStorage:', carrinhoFinal);
          setCartItems(carrinhoFinal);
        } else if (loginData) {
          // Só buscar do servidor se não tiver dados locais
          try {
            const response = await buscar_interesses({
              usuario: loginData,  // Email/token do usuário (como sistema antigo)
              loja: window.location.search.split('=')[1] || sessionStorage.getItem('loja') || '1'
            });

            if (response && response.data && response.data.car) {
              console.log('Carrinho do servidor (fallback):', response.data.car);
              setCartItems(response.data.car);
            }
          } catch (error) {
            console.warn('Erro ao buscar carrinho do servidor:', error);
          }
        }
      } catch (error) {
        console.error('Erro ao carregar dados:', error);
        addToast('Erro ao carregar dados do checkout', 'error');
      } finally {
        setLoading(false);
      }
    };

    loadData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // Array vazio - executar apenas uma vez para evitar re-renders

  const getTotalPrice = () => {
    return cartItems.reduce((total, item) => {
      // Tentar múltiplas formas de extrair o preço
      const preco = parseFloat(item.preco) || 
                   parseFloat(item.produto?.preco) || 
                   parseFloat(item.props?.preco) ||
                   0;
      
      // Tentar múltiplas formas de extrair a quantidade
      const quantidade = parseInt(item.quantidade) || 
                        parseInt(item.qtd) ||
                        parseInt(item.produto?.quantidade) ||
                        1;
      
      return total + (preco * quantidade);
    }, 0);
  };

    const formatPrice = (price) => {
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL'
    }).format(price || 0);
  };

  // Função para aumentar quantidade de um item
  const aumentarQuantidade = (itemIndex) => {
    const newCartItems = [...cartItems];
    const item = newCartItems[itemIndex];
    
    // Aumentar quantidade
    const novaQuantidade = (parseInt(item.quantidade) || 1) + 1;
    item.quantidade = novaQuantidade;
    
    // Atualizar no sessionStorage
    updateSessionStorage(newCartItems);
    setCartItems(newCartItems);
    addToast('Quantidade atualizada', 'success');
  };

  // Função para diminuir quantidade de um item
  const diminuirQuantidade = (itemIndex) => {
    const newCartItems = [...cartItems];
    const item = newCartItems[itemIndex];
    const quantidadeAtual = parseInt(item.quantidade) || 1;
    
    if (quantidadeAtual > 1) {
      // Diminuir quantidade apenas se for maior que 1
      item.quantidade = quantidadeAtual - 1;
      
      // Atualizar no sessionStorage
      updateSessionStorage(newCartItems);
      setCartItems(newCartItems);
      addToast('Quantidade atualizada', 'success');
    }
    // Se quantidade for 1, não faz nada (botão fica desabilitado)
  };

  // Função para remover item do carrinho
  const removerItem = (itemIndex) => {
    const newCartItems = cartItems.filter((_, index) => index !== itemIndex);
    
    // Atualizar no sessionStorage
    updateSessionStorage(newCartItems);
    setCartItems(newCartItems);
    addToast('Item removido do carrinho', 'success');
  };

  // Função para atualizar sessionStorage
  const updateSessionStorage = (items) => {
    if (items.length === 0) {
      sessionStorage.removeItem('comprar');
    } else {
      const itemsString = items.map(item => JSON.stringify(item)).join(';');
      sessionStorage.setItem('comprar', itemsString);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));

    // Se for o campo CEP e tiver 8 dígitos, buscar endereço com debounce
    if (name === 'cep' && value.replace(/\D/g, '').length === 8) {
      // Limpar timeout anterior se existir
      if (window.cepTimeout) {
        clearTimeout(window.cepTimeout);
      }
      
      // Criar novo timeout para debounce
      window.cepTimeout = setTimeout(() => {
        buscarEnderecoPorCEP(value.replace(/\D/g, ''));
      }, 500); // 500ms de delay
    }
  };

  // Função para buscar endereço pelo CEP (memoizada para evitar re-renders)
  const buscarEnderecoPorCEP = useCallback(async (cep) => {
    try {
      const response = await fetch(`https://viacep.com.br/ws/${cep}/json/`);
      const data = await response.json();
      
      if (!data.erro) {
        setFormData(prev => ({
          ...prev,
          endereco: data.logradouro || '',
          cidade: data.localidade || '',
          estado: data.uf || '',
          bairro: data.bairro || ''
        }));
        addToast('Endereço preenchido automaticamente', 'success');
      }
    } catch (error) {
      console.warn('Erro ao buscar CEP:', error);
    }
  }, [addToast]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!formData.nomeCompleto || !formData.email || !formData.telefone || 
        !formData.cep || !formData.endereco || !formData.numero || 
        !formData.bairro || !formData.cidade || !formData.estado) {
      addToast('Por favor, preencha todos os campos obrigatórios', 'error');
      return;
    }

    try {
      setLoading(true);

      // Pegar dados da sessão - usar login do usuário
      const usuario = sessionStorage.getItem('login');
      const loja = sessionStorage.getItem('loja') || sessionStorage.getItem('id_loja');

      if (!loja) {
        console.error('❌ ID da loja não encontrado');
        addToast('Erro: loja não identificada', 'error');
        return;
      }

      // Preparar itens do carrinho
      console.log('Preparando itens do carrinho para envio:', cartItems);
      const itensCarrinho = cartItems.map(item => ({
        item: {
          id: item.produto_id || item.id,
          quantity: item.quantidade || item.qty || 1,
          price: parseFloat(item.preco) || parseFloat(item.price) || 0
        }
      }));

      // Dados para enviar
      const dadosEnvio = {
        dict_inputs: {
          loja: loja,
          login: usuario,  // Email/token do usuário (como sistema antigo)
          itens: itensCarrinho,
          dadosEndereco: {
            nomeCompleto: formData.nomeCompleto,
            email: formData.email,
            telefone: formData.telefone,
            cep: formData.cep,
            endereco: formData.endereco,
            numero: formData.numero,
            bairro: formData.bairro,
            cidade: formData.cidade,
            estado: formData.estado
          }
        }
      };

      console.log('Enviando dados do pedido:', dadosEnvio);

      // Fazer requisição para o backend usando a API
      const response = await checkout(dadosEnvio);

      if (response.data.data !== false) {
        console.log('✅ Pedido realizado com sucesso!');
        addToast('Pedido realizado com sucesso!', 'success');

        // Limpar carrinho local
        sessionStorage.removeItem('comprar');

        // Verificar se tem telefone da loja para mostrar modal do WhatsApp
        const telefoneLoja = sessionStorage.getItem('telefone_loja');
        console.log('📞 Telefone da loja no sessionStorage:', telefoneLoja);
        console.log('🔍 Todos os dados do sessionStorage:', {
          telefone_loja: sessionStorage.getItem('telefone_loja'),
          loja: sessionStorage.getItem('loja'),
          login: sessionStorage.getItem('login')
        });

        if (telefoneLoja && telefoneLoja !== 'null' && telefoneLoja !== 'undefined') {
          console.log('✅ Mostrando modal do WhatsApp');
          // Mostrar modal antes de redirecionar
          setShowWhatsAppModal(true);
        } else {
          console.log('⚠️ Sem telefone, redirecionando direto');
          // Se não tiver telefone, redirecionar direto
          setTimeout(() => {
            history.push('/pedidos_cliente');
          }, 2000);
        }
      } else {
        addToast(response.data.msg || 'Erro ao processar pedido', 'error');
      }
      
    } catch (error) {
      console.error('Erro ao finalizar pedido:', error);
      addToast('Erro ao finalizar pedido. Tente novamente.', 'error');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <ModernLoader message="Carregando checkout..." />;
  }

  if (cartItems.length === 0) {
    return (
      <ModernLayout title="Checkout" showBackButton>
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-md-6">
              <div className="text-center py-5">
                <i className="bi bi-bag-x fs-1 text-muted mb-3"></i>
                <h4>Carrinho vazio</h4>
                <p className="text-muted mb-4">
                  Adicione produtos ao seu carrinho para finalizar a compra
                </p>
                <button 
                  className="btn btn-modern text-white"
                  onClick={() => history.push('/')}
                >
                  <i className="bi bi-arrow-left me-2"></i>
                  Continuar comprando
                </button>
              </div>
            </div>
          </div>
        </div>
      </ModernLayout>
    );
  }

  return (
    <ModernLayout title="Finalizar Compra" showBackButton>
      <div className="modern-checkout">
        <div className="container">
          <div className="row">
            {/* Formulário de checkout */}
            <div className="col-lg-8">
              <form id="checkout-form" onSubmit={handleSubmit}>
                {/* Dados pessoais */}
                <div className="modern-card">
                  <div className="card-header">
                    <h5>
                      <i className="bi bi-person me-2"></i>
                      Dados Pessoais
                    </h5>
                  </div>
                  <div className="card-body">
                    <div className="row">
                      <div className="col-md-6 mb-3">
                        <label className="form-label">Nome Completo *</label>
                        <input
                          type="text"
                          className="form-control"
                          name="nomeCompleto"
                          value={formData.nomeCompleto}
                          onChange={handleInputChange}
                          required
                        />
                      </div>
                      <div className="col-md-6 mb-3">
                        <label className="form-label">E-mail *</label>
                        <input
                          type="email"
                          className="form-control"
                          name="email"
                          value={formData.email}
                          onChange={handleInputChange}
                          required
                        />
                      </div>
                      <div className="col-12 mb-3">
                        <label className="form-label">Telefone *</label>
                        <input
                          type="tel"
                          className="form-control"
                          name="telefone"
                          value={formData.telefone}
                          onChange={handleInputChange}
                          required
                        />
                      </div>
                    </div>
                  </div>
                </div>

                {/* Endereço de entrega */}
                <div className="modern-card">
                  <div className="card-header">
                    <h5>
                      <i className="bi bi-geo-alt me-2"></i>
                      Endereço de Entrega
                    </h5>
                  </div>
                  <div className="card-body">
                    <div className="row">
                      <div className="col-md-3 mb-3">
                        <label className="form-label">CEP *</label>
                        <input
                          type="text"
                          className="form-control"
                          name="cep"
                          value={formData.cep}
                          onChange={handleInputChange}
                          placeholder="00000-000"
                          maxLength="9"
                          required
                        />
                        <small className="text-muted">Digite o CEP para preencher automaticamente</small>
                      </div>
                      <div className="col-md-7 mb-3">
                        <label className="form-label">Endereço *</label>
                        <input
                          type="text"
                          className="form-control"
                          name="endereco"
                          value={formData.endereco}
                          onChange={handleInputChange}
                          placeholder="Rua, Avenida, etc."
                          required
                        />
                      </div>
                      <div className="col-md-2 mb-3">
                        <label className="form-label">Número *</label>
                        <input
                          type="text"
                          className="form-control"
                          name="numero"
                          value={formData.numero}
                          onChange={handleInputChange}
                          placeholder="123"
                          required
                        />
                      </div>
                      <div className="col-md-4 mb-3">
                        <label className="form-label">Bairro *</label>
                        <input
                          type="text"
                          className="form-control"
                          name="bairro"
                          value={formData.bairro}
                          onChange={handleInputChange}
                          required
                        />
                      </div>
                      <div className="col-md-5 mb-3">
                        <label className="form-label">Cidade *</label>
                        <input
                          type="text"
                          className="form-control"
                          name="cidade"
                          value={formData.cidade}
                          onChange={handleInputChange}
                          required
                        />
                      </div>
                      <div className="col-md-3 mb-3">
                        <label className="form-label">Estado *</label>
                        <select
                          className="form-select"
                          name="estado"
                          value={formData.estado}
                          onChange={handleInputChange}
                          required
                        >
                          <option value="">UF</option>
                          <option value="AC">AC</option>
                          <option value="AL">AL</option>
                          <option value="AP">AP</option>
                          <option value="AM">AM</option>
                          <option value="BA">BA</option>
                          <option value="CE">CE</option>
                          <option value="DF">DF</option>
                          <option value="ES">ES</option>
                          <option value="GO">GO</option>
                          <option value="MA">MA</option>
                          <option value="MT">MT</option>
                          <option value="MS">MS</option>
                          <option value="MG">MG</option>
                          <option value="PA">PA</option>
                          <option value="PB">PB</option>
                          <option value="PR">PR</option>
                          <option value="PE">PE</option>
                          <option value="PI">PI</option>
                          <option value="RJ">RJ</option>
                          <option value="RN">RN</option>
                          <option value="RS">RS</option>
                          <option value="RO">RO</option>
                          <option value="RR">RR</option>
                          <option value="SC">SC</option>
                          <option value="SP">SP</option>
                          <option value="SE">SE</option>
                          <option value="TO">TO</option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>

                
              </form>
            </div>

            {/* Resumo do pedido */}
            <div className="col-lg-4">
              <div className="modern-card sticky-top">
                <div className="card-header">
                  <h5>
                    <i className="bi bi-bag me-2"></i>
                    Resumo do Pedido
                  </h5>
                </div>
                <div className="card-body">
                  <div className="checkout-items">
                    {cartItems.length > 0 ? cartItems.map((item, index) => {
                      // Tentar múltiplas formas de extrair o nome do produto
                      const nomeProduto = item.nome || 
                                         item.descricao || 
                                         item.produto?.descricao || 
                                         item.produto?.nome ||
                                         (item.props?.detalhes?.DESC_PRODUTO) ||
                                         `Produto ${item.id || index + 1}`;
                      
                      // Tentar múltiplas formas de extrair o preço
                      const preco = parseFloat(item.preco) || 
                                   parseFloat(item.produto?.preco) || 
                                   parseFloat(item.props?.preco) ||
                                   parseFloat(item.price) ||
                                   parseFloat(item.valor) ||
                                   0;
                      
                      // Tentar múltiplas formas de extrair a quantidade
                      const quantidade = parseInt(item.quantidade) || 
                                        parseInt(item.qtd) ||
                                        parseInt(item.produto?.quantidade) ||
                                        parseInt(item.quantity) ||
                                        1;

                      // Tentar múltiplas formas de extrair a URL da imagem
                      const imagemUrl = item.img || 
                                       item.imagem || 
                                       item.image || 
                                       item.produto?.img ||
                                       item.produto?.imagem ||
                                       '';

                      console.log('Renderizando item checkout detalhado:', {
                        index, 
                        item: item, 
                        nomeProduto, 
                        imagemUrl,
                        preco: {
                          original: item.preco,
                          produto: item.produto?.preco,
                          props: item.props?.preco,
                          price: item.price,
                          valor: item.valor,
                          final: preco
                        },
                        quantidade: {
                          original: item.quantidade,
                          qtd: item.qtd,
                          produto: item.produto?.quantidade,
                          quantity: item.quantity,
                          final: quantidade
                        }
                      });

                      return (
                        <div key={index} className="border-bottom py-3 mb-2">
                          <div className="d-flex align-items-center">
                            <div className="me-3">
                              {imagemUrl && (
                                <img 
                                  src={imagemUrl} 
                                  alt={nomeProduto}
                                  className="rounded"
                                  style={{ 
                                    width: '60px', 
                                    height: '60px', 
                                    objectFit: 'cover',
                                    border: '1px solid #e0e0e0'
                                  }}
                                  onError={(e) => {
                                    e.target.style.display = 'none';
                                  }}
                                />
                              )}
                              {!imagemUrl && (
                                <div 
                                  className="d-flex align-items-center justify-content-center bg-light rounded"
                                  style={{ 
                                    width: '60px', 
                                    height: '60px',
                                    border: '1px solid #e0e0e0'
                                  }}
                                >
                                  <i className="bi bi-image text-muted"></i>
                                </div>
                              )}
                            </div>
                            <div className="flex-grow-1">
                              <h6 className="mb-1">{nomeProduto}</h6>
                              <small className="text-muted">Preço unit.: {formatPrice(preco)}</small>
                            </div>
                            <div className="text-end">
                              <strong>{formatPrice(preco * quantidade)}</strong>
                            </div>
                          </div>
                          
                          {/* Linha dos controles */}
                          <div className="d-flex justify-content-between align-items-center mt-3">
                            <div className="d-flex align-items-center">
                              <span className="text-muted me-3">Quantidade:</span>
                              <div className="d-flex align-items-center">
                                <button 
                                  className={`btn btn-sm ${quantidade === 1 ? 'btn-outline-secondary' : 'btn-outline-secondary'}`}
                                  style={{ 
                                    width: '32px', 
                                    height: '32px',
                                    padding: '0',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    opacity: quantidade === 1 ? 0.5 : 1
                                  }}
                                  onClick={() => diminuirQuantidade(index)}
                                  disabled={quantidade === 1}
                                  title={quantidade === 1 ? "Quantidade mínima" : "Diminuir quantidade"}
                                >
                                  <i className="bi bi-dash" style={{ fontSize: '16px' }}></i>
                                </button>
                                <span className="mx-2 fw-bold" style={{ minWidth: '30px', textAlign: 'center', fontSize: '16px' }}>
                                  {quantidade}
                                </span>
                                <button 
                                  className="btn btn-outline-secondary btn-sm"
                                  style={{ 
                                    width: '32px', 
                                    height: '32px',
                                    padding: '0',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center'
                                  }}
                                  onClick={() => aumentarQuantidade(index)}
                                  title="Aumentar quantidade"
                                >
                                  <i className="bi bi-plus" style={{ fontSize: '16px' }}></i>
                                </button>
                              </div>
                            </div>
                            <button 
                              className="btn btn-outline-danger btn-sm"
                              style={{ 
                                width: '32px', 
                                height: '32px',
                                padding: '0',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center'
                              }}
                              onClick={() => removerItem(index)}
                              title="Remover do carrinho"
                            >
                              <i className="bi bi-trash" style={{ fontSize: '14px' }}></i>
                            </button>
                          </div>
                        </div>
                      );
                    }) : (
                      <div className="text-center py-3">
                        <i className="bi bi-bag-x fs-3 text-muted mb-2"></i>
                        <p className="text-muted mb-0">Nenhum item no carrinho</p>
                      </div>
                    )}
                  </div>
                  
                  <div className="border-top pt-3 mt-3">
                    <div className="d-flex justify-content-between align-items-center mb-2">
                      <span>Subtotal:</span>
                      <strong>{formatPrice(getTotalPrice())}</strong>
                    </div>
                    <div className="d-flex justify-content-between align-items-center mb-2">
                      <span>Frete:</span>
                      <strong>A combinar</strong>
                    </div>
                    <hr />
                    <div className="d-flex justify-content-between align-items-center">
                      <h5 className="mb-0">Total:</h5>
                      <h5 className="mb-0 text-primary">{formatPrice(getTotalPrice())}</h5>
                    </div>
                  </div>

                  <button
                    type="submit"
                    className="btn btn-modern w-100 mt-3 text-white"
                    form="checkout-form"
                  >
                    <i className="bi bi-check-circle me-2"></i>
                    Finalizar Pedido
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Sidebar do carrinho */}
      <ModernCartSidebar
        isOpen={showCartSidebar}
        onClose={() => setShowCartSidebar(false)}
        cartItems={cartItems}
        onUpdateCart={setCartItems}
      />

      {/* Modal do WhatsApp após finalizar pedido */}
      {console.log('🎨 Renderizando ModernWhatsAppModal - isOpen:', showWhatsAppModal, 'telefone:', sessionStorage.getItem('telefone_loja'))}
      <ModernWhatsAppModal
        isOpen={showWhatsAppModal}
        onClose={() => {
          console.log('❌ Fechando modal do WhatsApp');
          setShowWhatsAppModal(false);
          // Redirecionar após fechar o modal
          history.push('/pedidos_cliente');
        }}
        telefone={sessionStorage.getItem('telefone_loja')}
      />
    </ModernLayout>
  );
}

export default ModernCheckout;
